@if(displayHeader){
<div class="filter my-20 mb-18 top align-items-center g-just-flex flex-wrap flex-between gap-20">
    <div class="filter-top-left flex-wrap g-just-flex gap-10">
        @for(filterKey of filterKeys; track filterKey){
        <div class="expansion-wrapper">
            <div class="expansion-trigger" expansion-target="ec" (click)="expand(ec)">
                <div class="expansion-header g-just-flex">
                    <div class="expansion-title">
                        {{filterKey | titlecase}}
                    </div>
                    <mat-icon class="expansion-icon">
                        chevron_right
                    </mat-icon>
                </div>
            </div>
            <div class="expansion-content" #ec>
                @if(patientsFiltersFormControlObject[filterKey]; as filterFormGroup){
                @for(eachOption of patientsTableFilterArray.get(filterKey); track eachOption){
                <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
                    <mat-checkbox [formControl]="$any(filterFormGroup.get(eachOption))" [id]="eachOption">
                        {{ eachOption | titlecase }}
                    </mat-checkbox>
                </div>
                }
                }
            </div>
        </div>
        }
    </div>

    <div class="filter-top-right g-just-flex gap-10"
        style="flex-wrap: wrap; flex: 1 1 max-content; justify-content: flex-end;">
        @if(searchableFields?.length){
        <mat-form-field appearance="outline" class="search-by-field"
            [ngClass]="{ 'has-value': !!searchFieldControl.value }">
            <mat-label>Search By</mat-label>
            <mat-select [formControl]="searchFieldControl">
                @for(option of searchableFields; track option.value){
                <mat-option [value]="option.value">{{option.label}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
        <mat-form-field appearance="outline" class="search-input-field" floatLabel="always">
            <mat-label>{{searchBoxTitle ?? 'Search'}}</mat-label>
            <input type="text" matInput [formControl]="searchControl" placeholder="Search...">
            <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
    </div>
</div>

<!-- Active Filters Display -->
<div class="filter active filters bottom mb-25 g-just-flex flex-wrap justify-content-start">
    <div class="bottom-right g-just-flex flex-wrap justify-content-start">
        <mat-chip-set class="mxc">
            @for(activeFilter of getActiveFilters(); track activeFilter.filterKey){
            @for(value of activeFilter.values; track value){
            <mat-chip class="chip8 m-8 py-5 px-10">
                <span>{{activeFilter.filterKey | titlecase}}: {{value | titlecase}}</span>
                <button matChipRemove class="ms-8" (click)="clearFilter(activeFilter.filterKey)">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-chip>
            }
            }

            <!-- Show clear all button if any filters active -->
            @if (hasAnyFilters()) {
            <mat-chip class="chip8 m-8 py-5 px-10" style="background-color: #ffebee;">
                <span style="color: #d32f2f;">Clear All</span>
                <button matChipRemove class="ms-8" (click)="clearAllFilters()" style="color: #d32f2f;">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-chip>
            }
        </mat-chip-set>
    </div>
</div>
}